export type ApiError =
  | { kind: 'network';      message: string }
  | { kind: 'timeout';      message: string }
  | { kind: 'authentication'; code: 'invalid_credentials' | 'token_expired' | 'no_token'; message: string }
  | { kind: 'authorization'; message: string }
  | { kind: 'not_found';    message: string }
  | { kind: 'validation';   fields: Record<string, string[]>; message: string }
  | { kind: 'rate_limit';   retryAfterMs: number; message: string }
  | { kind: 'business';     code: string; message: string }
  | { kind: 'backend_bug';  bugId: 'personUser' | 'fopen_photo' | 'sqlstate_22p02'; message: string; original: unknown }
  | { kind: 'server';       status: number; message: string }
  | { kind: 'unknown';      message: string; original: unknown };

export function isApiError(value: unknown): value is ApiError {
  return (
    typeof value === 'object' &&
    value !== null &&
    'kind' in value &&
    typeof (value as { kind: unknown }).kind === 'string'
  );
}
